
Array.prototype.remove = function(val) {
  var index = this.indexOf(val);
  if (index > -1) {
    this.splice(index, 1);
  }
};



// WEBPACK FOOTER //
// ./src/assets/js/myfunction.js